import apiClient from '@/api/index';
import router from '@/router';
import { reportStudyModule } from './reportStudyModule';

export const reportStudyNewModule = {
    ...reportStudyModule,
    state: () => ({ ...reportStudyModule.state(), reportError: '', filtersetError: '', requestId: 0 }),
    mutations: {
        ...reportStudyModule.mutations,
        setReportData(state, data) { state.reportData = data; state.reportLoading = false; },
        setReportFilterset(state, data) {
            const query = router.currentRoute.value.query;
            const specs = {};
            for (const [key, filter] of Object.entries(data)) {
                if (!Array.isArray(filter?.choices)) continue;
                const defaults = filter.choices.filter(choice => choice.checked).map(choice => choice.value);
                const supplied = query[key] === undefined ? defaults : [].concat(query[key]);
                const values = supplied.map(value => filter.choices.find(choice => String(choice.value) === String(value))?.value).filter(value => value !== undefined);
                specs[key] = filter.multi_choices ? values : (values[0] ?? '');
            }
            state.filterSpecs = specs;
            state.filterset = data;
            state.filtersetLoading = false;
        },
    },
    actions: {
        ...reportStudyModule.actions,
        async getReportData({ state, commit }) {
            const requestId = ++state.requestId;
            state.reportLoading = true;
            state.reportError = '';
            try {
                const response = await apiClient.get('/reports/study/data', { params: router.currentRoute.value.query, paramsSerializer: { indexes: null } });
                if (requestId !== state.requestId) return;
                commit('setReportData', response.data.data);
                commit('setExcelData', response.data);
            } catch (_) {
                if (requestId === state.requestId) state.reportError = 'Не удалось загрузить обучение. Попробуйте применить фильтры ещё раз.';
            } finally {
                if (requestId === state.requestId) state.reportLoading = false;
            }
        },
        async getReportFilterset({ state, commit }) {
            state.filtersetLoading = true;
            state.filtersetError = '';
            try {
                const response = await apiClient.get('/reports/study/filterset');
                commit('setReportFilterset', response.data);
            } catch (_) {
                state.filtersetError = 'Не удалось загрузить фильтры. Обновите страницу.';
            } finally { state.filtersetLoading = false; }
        },
        async getExcelFile({ state }, layout) {
            try {
                const payload = layout ? { ...state.excelData, title: 'Обучение Новый', data: { ...state.excelData.data, ...layout } } : state.excelData;
                const response = await apiClient.post('/reports/export_to_excel/', payload, { responseType: 'blob' });
                const url = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Обучение Новый_${new Date().toLocaleDateString('ru-RU')}.xls`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
            } catch (_) { state.reportError = 'Не удалось экспортировать отчёт. Попробуйте ещё раз.'; }
        },
    },
};
